module.exports = __webpack_public_path__ + "img/Icon-survey-un-locked-disabled.0a868919.svg";